import React from 'react';
import { Check } from 'lucide-react';

export interface ShopCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    id?: string;
    name?: string;
    className?: string;
    'aria-label'?: string;
    /** Extra classes on the visible box (default uses accent CSS vars). */
    boxClassName?: string;
}

/**
 * Shop-only styled checkbox (exclude admin).
 * Larger touch target; uses SiteSettings --accent-color / --text-color.
 */
const ShopCheckbox: React.FC<ShopCheckboxProps> = ({
    checked,
    onChange,
    disabled,
    id,
    name,
    className = '',
    boxClassName = '',
    'aria-label': ariaLabel,
}) => {
    return (
        <span className={`relative inline-flex h-5 w-5 shrink-0 items-center justify-center ${className}`}>
            <input
                id={id}
                name={name}
                type="checkbox"
                checked={checked}
                disabled={disabled}
                aria-label={ariaLabel}
                onChange={(e) => onChange(e.target.checked)}
                className="peer absolute inset-0 z-10 m-0 h-full w-full cursor-pointer opacity-0 disabled:cursor-not-allowed"
            />
            <span
                aria-hidden
                className={`pointer-events-none flex h-5 w-5 items-center justify-center rounded-md border-2 transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-[var(--highlight-color,var(--accent-color))] peer-focus-visible:ring-offset-1 peer-disabled:opacity-50 ${
                    checked
                        ? 'border-transparent bg-[var(--accent-color)] text-white'
                        : 'border-[color-mix(in_srgb,var(--accent-color),transparent_35%)] bg-[color-mix(in_srgb,var(--bg-color),white_40%)]'
                } ${boxClassName}`}
            >
                {checked && <Check className="h-3.5 w-3.5 stroke-[3]" />}
            </span>
        </span>
    );
};

export default ShopCheckbox;
